import React from 'react';
import { Button, Icon, Loader, Popup, Segment } from 'ui';

function DefaultFallback({ removeError, isOutdated, ...props }) {
  if (isOutdated) {
    return (
      <div className="flex justify-center pt-12">
        <Segment>
          <div className="flex max-w-lg flex-col items-center text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <Icon name="rewind" className="h-6 w-6 text-red-600" />
            </div>
            <h1 className="text-lg font-bold">{gettext('New version of Retino available.')}</h1>
            <p className="my-1 text-sm text-gray-800">{gettext("We've just released a new version of Retino.")}</p>
            <div className="mt-4 flex justify-center gap-2">
              <Button primary onClick={() => window.location.reload()}>
                {gettext('Refresh')}
              </Button>
            </div>
          </div>
        </Segment>
      </div>
    );
  }

  return (
    <div className="flex justify-center pt-12">
      <Segment>
        <div className="flex max-w-lg flex-col items-center text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <Icon name="exclamation" className="h-6 w-6 text-red-600" />
          </div>
          <h1 className="text-lg font-bold">{gettext("There was an error and we couldn't process your request.")}</h1>
          <p className="my-1" />
          <p className="my-1 text-sm text-gray-800">
            {gettext(
              'Please reload the page and try again. If the error prevails, please contact our support and we will help you.',
            )}
          </p>
          <div className="mt-4 flex justify-center gap-2">
            <Button primary onClick={() => window.location.reload()}>
              {gettext('Try again')}
            </Button>

            <Popup
              on="hover"
              trigger={
                <Button>
                  <a href="mailto:support@retino.com">{gettext('Contact support')}</a>
                </Button>
              }
            >
              <span>support@retino.com</span>
            </Popup>
          </div>
        </div>
      </Segment>
    </div>
  );
}

export default DefaultFallback;
